// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__3BPvn","link":"dashboard_link__2eMpE"};